import React, { useContext, useState } from 'react';
import { ShopContext } from '../context/ShopContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { assets } from '../assets/assets';
import { IoAlertCircleOutline } from "react-icons/io5";

const Checkout = () => {
    const { cartItem } = useContext(ShopContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [tipPercentage, setTipPercentage] = useState(10); // Default tip percentage

    // Get the total donation amount from the location state if available
    const initialTotalDonationAmount = location.state?.totalDonationAmount || 0;

    // Calculate total donation amount
    const calculateTotal = () => {
        let total = 0;
        for (const title in cartItem) {
            for (const subId in cartItem[title]) {
                for (const productName in cartItem[title][subId]) {
                    const product = cartItem[title][subId][productName];
                    total += product.price * product.quantity;
                }
            }
        }
        return total;
    };

    const totalDonationAmount = calculateTotal() + initialTotalDonationAmount;

    // Calculate the tip amount based on the selected percentage
    const tipAmount = (totalDonationAmount * tipPercentage) / 100;

    // Handle tip percentage change
    const handleTipChange = (e) => {
        setTipPercentage(Number(e.target.value));
    };

    // Determine the main product type (one-time or monthly)
    const determineMainProductType = () => {
        let isMonthly = false;
        let isOneTime = false;

        for (const title in cartItem) {
            for (const subId in cartItem[title]) {
                for (const productName in cartItem[title][subId]) {
                    const product = cartItem[title][subId][productName];
                    if (product.type === 'monthly') {
                        isMonthly = true;
                    } else if (product.type === 'one-time') {
                        isOneTime = true;
                    }
                }
            }
        }

        if (isMonthly) return "monthly";
        if (isOneTime) return "one-time";
        return ""; // or default type if necessary
    };

    const mainProductType = determineMainProductType();

    // Handle proceeding to the Donar page
    const handleProceedToDonar = () => {
        navigate('/checkout/donar', { state: { totalDonationAmount, tipAmount } });
    };

    return (
        <div>
            <div className="checkout_section pt-3 pb-5 pt-md-5">
                <div className="cart_heading" style={{ minHeight: '125px' }}>
                    <div className="container">
                        <div className="row g-2 d-flex align-items-center justify-content-center">
                            <div className="item-box col-lg-8 col-xl-6 d-flex justify-content-center">
                                <div className="col-4">
                                    <div className="gateway_process position-relative overflow-hidden text-center">
                                        <div className="numbr-box bg-warning">01</div>
                                        <div className="process-name mt-2">Donation Details</div>
                                        
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="gateway_process position-relative overflow-hidden text-center">
                                        <div className="numbr-box bg-white">02</div>
                                        <div className="process-name mt-2">Personal Details</div>
                                    </div>
                                </div>
                                <div className="col-4">
                                    <div className="gateway_process position-relative overflow-hidden text-center">
                                        <div className="numbr-box bg-white">03</div>
                                        <div className="process-name mt-2">Payment Gateway</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-xl-8">
                            <div className="cart-box">
                                <div className="send-mgs pb-4 text-center text-sm-start">
                                    <h2>Donation Details</h2>
                                    <div className="common-details common-ssd">
                              <p><IoAlertCircleOutline/>To claim an 80G certificate or tax redemption for your donation, provide your PAN card information.</p>
                             </div>
                                </div>
                                {Object.keys(cartItem).length === 0 ? (
                                    <p className="text-center">Your cart is empty.</p>
                                ) : (
                                    Object.keys(cartItem).map((title) => 
                                        Object.keys(cartItem[title]).map((subId) => 
                                            Object.keys(cartItem[title][subId]).map((productName) => {
                                                const product = cartItem[title][subId][productName];
                                                return (
                                                    <div className="cart_item overflow-hidden bg-white" key={`${title}-${subId}-${productName}`}>
                                                        <h4 className="cart-title mb-3">{productName}</h4>
                                                        <div className="d-md-flex align-items-center justify-content-between">
                                                            <div className="d-flex align-items-center mb-5 mb-sm-0">
                                                                <div className="product_img me-3">
                                                                    <img src={assets.logo} className="img-fluid" alt={productName}/>
                                                                </div>
                                                                <div className="link_txt">
                                                                    <strong className="unit">{product.price}/Unit</strong>
                                                                    <p className="name">Food Packets (20 Kids)</p>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex align-items-center justify-content-between">
                                                                <div className="quantity me-0 me-sm-5">
                                                                    <button className="minus-btn">-</button>
                                                                    <input type="text" className="border-0 bg-transparent" readOnly value={product.quantity}/>
                                                                    <button className="plus-btn">+</button>
                                                                </div>
                                                                <div className="icon">
                                                                    <button type="button" className="bg-transparent border-0">
                                                                        <img className="img-fluid close-btn" src={assets.close_icon} alt="Close"/>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        )
                                    )
                                )}
                            </div>
                        </div>
                        <div className="col-xl-4">
                            <div className="card-box send-mgs">
                                <h2 className="mb-4">Payment Details</h2>
                                <div className="card-box-item d-flex justify-content-between">
                                    <p>Special Request Charge</p>
                                    <span className="price">₹ 0</span>
                                </div>
                                <div className="card-box-item d-flex justify-content-between">
                                    <p>Tip amount</p>
                                    <span className="price">₹ {tipAmount.toFixed(2)}</span>
                                </div>
                                <div className="card-box-item d-flex justify-content-between">
                                    <p>Donated Amount</p>
                                    <span className="price">₹ {totalDonationAmount.toFixed(2)}</span>
                                </div>
                                <div className="card-box-item d-flex justify-content-between border-top border-dark mt-4 pt-3">
                                    <strong>Total Donation Amount</strong>
                                    <strong>₹ {(totalDonationAmount + tipAmount).toFixed(2)}</strong>
                                </div>
                            </div>

                            <div className="sub-card">
                                <p>By tipping Ihskasfoundation, you support us to grow our impact and connect with more initiatives. Thank you 🙏.</p>
                                <div className="card-box-item align-items-center d-flex justify-content-between mt-3">
                                    <select className="form-control form-select me-3" style={{ width: '127px' }} value={tipPercentage} onChange={handleTipChange}>
                                        <option value="1">1%</option>
                                        <option value="10">10%</option>
                                        <option value="20">20%</option>
                                    </select>
                                    <span id="tip-amount">Tip Amount : ₹{tipAmount.toFixed(2)}</span>
                                </div>
                            </div>
                            <div className="btn-box">
                                <button 
                                    className="btn btn-primary d-flex align-items-center justify-content-center w-100 pay-btn shadow-none rounded-3"
                                    onClick={handleProceedToDonar}
                                >
                                    <div>
                                        {mainProductType === "monthly" ? "Donate Monthly" : "Donate One-Time"}
                                        <MdKeyboardArrowRight />
                                    </div>
                                    <span>₹ {(totalDonationAmount + tipAmount).toFixed(2)}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Checkout;
